import React from 'react';
import YouTube from 'react-youtube';
import './tutorial.scss';

export default function Tutorial() {
const videoId = 'QUClf8JUh4Y'; // Replace with your video ID

const opts = {
  playerVars: {
    // https://developers.google.com/youtube/player_parameters
    autoplay: 0,
    controls: 1,
    rel: 0,
    modestbranding: 1,
  },
};

return (
  <div className="video-container">
    <YouTube 
      videoId={videoId} 
      opts={opts} 
      className="video-player"
    />
  </div>
);
}